import { Editor, Plugin, UpcastElementEvent, Table } from "ckeditor5";

export default class TableBlockAlignment extends Plugin {
  static get requires() {
    return [Table];
  }

  private defaultAlignment: string | undefined;

  constructor(editor: Editor) {
    super(editor);

    this.defaultAlignment =
      this.editor.config.get(
        "table",
      )?.tableProperties?.defaultProperties?.alignment;
  }

  init() {
    this.editor.conversion.for("downcast").attributeToAttribute({
      model: {
        name: "table",
        key: "tableAlignment",
      },
      view: (alignment, { consumable }, { item }) => {
        switch (alignment) {
          case "right":
            return {
              key: "style",
              value: { "margin-left": "auto", "margin-right": "0" },
            };
          case "center":
            return {
              key: "style",
              value: { "margin-left": "auto", "margin-right": "auto" },
            };
        }

        consumable.consume(item, "attribute:tableAlignment");
      },
      converterPriority: "highest",
    });

    this.editor.conversion.for("upcast").add((dispatcher) =>
      dispatcher.on<UpcastElementEvent>(
        "element",
        (e, data, api) => {
          if (
            data.viewItem.name !== "table" &&
            data.viewItem.name !== "figure"
          ) {
            return;
          }

          const left = data.viewItem.getStyle("margin-left");
          const right = data.viewItem.getStyle("margin-right");

          api.consumable.consume(data.viewItem, {
            attributes: ["margin-left", "margin-right"],
          });

          if (data.modelRange == null) return;

          const alignment = this.determineAlignment({ left, right });
          if (alignment != null && alignment !== this.defaultAlignment) {
            api.writer.setAttribute(
              "tableAlignment",
              alignment,
              data.modelRange,
            );
          }
        },
        { priority: "low" },
      ),
    );

    // this.editor.model.on<ModelInsertObjectEvent>(
    //   "insertObject",
    //   (e, [element]) => {
    //     if (element.name !== "table") return;
    //     if (defaultAlignment == null) return;
    //     if (element.getAttribute("tableAlignment") != null) return;

    //     this.editor.model.enqueueChange({ isUndoable: false }, (writer) => {
    //       writer.setAttribute("tableAlignment", defaultAlignment, element);
    //     });
    //   }
    // );
  }

  private determineAlignment(margins: {
    left: string | undefined;
    right: string | undefined;
  }) {
    const { left, right } = margins;

    if (left === "auto" && right === "auto") {
      return "center";
    }
    if (left === "auto") {
      return "right";
    }
    return "left";
  }
}
